import { has, isEmpty, isObject } from "lodash-es";

import { AppError } from "../app-error/app-error.model";
import { HttpErrorResponse, HttpErrorResponseErrors } from "../http-client/http-client.model";

import { Message, MessageErrorData, MessageScopeType, MessageType } from "./message.model";

export function toMessage(
	error: AppError | Error,
	context: string,
	scope = MessageScopeType.Local,
	type = MessageType.Error
): Message {
	return {
		context,
		scope,
		type,
		messageCode: getMessageCodeFromError(error),
		data: getMessageDataFromError(error),
	};
}

export function getMessageCodeFromError(error: AppError | Error): string {
	if (error instanceof Error) {
		return error.message;
	}
	// it may not be an AppError at runtime
	return has(error, "data.code") ? error.data.code : undefined;
}

export function getMessageDataFromError(error: AppError | Error): MessageErrorData | MessageErrorData[] | undefined {
	if (error instanceof Error || !isObject(error)) {
		return undefined;
	}

	const data = (error as AppError).data;

	// in case of CORS, if OPTIONS request fails, data is ProgressEvent, which provides no additional information
	if (!isObject(data) || (typeof ProgressEvent !== "undefined" && data instanceof ProgressEvent)) {
		return undefined;
	}

	const errors = (data as HttpErrorResponse).errors;
	if (!isEmpty(errors)) {
		return errors;
	}

	const fieldErrorResponse = data as HttpErrorResponseErrors;
	if (!isEmpty(fieldErrorResponse.field)) {
		return [
			{
				code: fieldErrorResponse.code,
				field: fieldErrorResponse.field,
			},
		];
	}

	return data as MessageErrorData | MessageErrorData[] | undefined;
}
